import EmptyIcon from '@assets/icons/empty-state.svg';
import { TEST_IDS } from '@constants/testIds.ts';

import { EmptyDescWrapper, EmptyTitleWrapper, EmptyWrapper } from './styled.tsx';

export const EmptyResult = ({
    title,
    description,
    bgColor,
}: {
    title: string;
    description: string;
    bgColor?: string;
}) => {
    return (
        <EmptyWrapper data-cy={TEST_IDS.SHARED.EMPTY_RESULT} $bgColor={bgColor}>
            <EmptyIcon />
            <EmptyTitleWrapper>{title}</EmptyTitleWrapper>
            <EmptyDescWrapper>{description}</EmptyDescWrapper>
        </EmptyWrapper>
    );
};
